<template>
  <div
    class="line-selection"
    :style="selectedEffectStyle"
    @mousedown="handleMouseDown"
    @contextmenu.prevent="handleContextMenu"
    ref="selection"
  >
    <!-- <template v-for="vd in ['t', 'b']">
      <div
        v-for="hd in ['r', 'l']"
        :key="vd + hd"
        :class="['effect-cover__handle', 'effect-cover__handle--' + vd + hd]"
        :style="{ cursor: getResizeCursor(vd + hd) }"
        @mousedown="handleMouseDown($event, vd + hd)"
      />
    </template> -->
    <div
      v-for="hd in ['r', 'l']"
      :key="hd"
      :class="['effect-cover__handle', 'line-selection-handle--' + hd]"
      :style="{ cursor: getResizeCursor(hd) }"
      @mousedown="handleMouseDown($event, hd)"
    />
  </div>
</template>
<script>
import { getEffectBoxStyle, rotateBy, isMac, betweenDelta } from '../../utils';
import { matchFilter } from '../../utils/util';

export default {
  props: ['selectedEffect'],
  data() {
    return { resizing: null };
  },
  computed: {
    current() {
      return this.$store.state.currentProgress;
    },
    playing() {
      return this.$store.state.playing;
    },
    activeFragment() {
      return this.$store.getters.activeFragment;
    },
    allEffects() {
      return this.$store.state.effects;
    },
    scale() {
      return this.$store.state.playerScale / 100;
    },
    dragging: {
      get() {
        return this.$store.state.effectDragging;
      },
      set(value) {
        this.$store.commit('handleEffectDrag', value);
      }
    },
    selectedEffectStyle() {
      label: if (!this.playing && this.selectedEffect) {
        if (this.activeFragment.background === this.selectedEffect.id) {
          break label;
        }
        if (!this.selectedEffect.locked) {
          const effectCopy = {
            ...this.selectedEffect
          };
          if (this.selectedEffect.container) {
            const efc = this.selectedEffect.content;
            const containerEFC = this.containerEffect.content;
            const containerCenter = { x: containerEFC.width / 2, y: containerEFC.height / 2 };
            const selfCenter = { x: efc.left + efc.width / 2, y: efc.top + efc.height / 2 };

            let rotate = efc.rotate;

            switch (containerEFC.flip) {
              case 'horizontal':
                selfCenter.x = containerEFC.width - selfCenter.x;
                rotate = -rotate;
                break;
              case 'vertical':
                selfCenter.y = containerEFC.height - selfCenter.y;
                rotate = -rotate;
                break;
            }

            const { x, y } = rotateBy(selfCenter, containerCenter, containerEFC.rotate);
            effectCopy.content = {
              ...efc,
              top: y + containerEFC.top - efc.height / 2,
              left: x + containerEFC.left - efc.width / 2,
              rotate: rotate + containerEFC.rotate
            };
          }
          let ret = getEffectBoxStyle(effectCopy);

          ['left', 'top', 'width', 'height'].forEach(key => {
            ret[key] = parseFloat(ret[key]) * this.scale + 'px';
          });

          return ret;
        }
      }
      return {
        display: 'none'
      };
    },
    containerEffect() {
      return (this.selectedEffect
        && this.selectedEffect.container
        && this.$store.state.effects[this.selectedEffect.container]
      ) || null;
    }
  },
  methods: {
    getResizeCursor(dir) {
      if (this.selectedEffect && this.selectedEffect.content) {
        let rotation = this.selectedEffect.content.rotate;
        if (this.containerEffect) {
          rotation += this.containerEffect.content.rotate || 0;
        }
        switch (dir) {
          case 't':
          case 'b':
            rotation += 90;
        }

        switch (Math.round((rotation + 180) % 180 / 45)) {
          case 0:
          case 4:
            return 'ew-resize';
          case 1:
            return 'nwse-resize';
          case 2:
            return 'ns-resize';
          case 3:
            return 'nesw-resize';
        }
      }
      return 'default';
    },
    handleMouseDown(e, dir) {
      if (!e.button) {
        const bcr = this.$parent.$el.getBoundingClientRect();
        let nextEffectId = null;

        const ctrlKey = isMac ? e.metaKey : e.ctrlKey;

        if (dir) {
          document.body.classList.add('unselectable');
          e.stopPropagation();
          // TODO: handle line resizing/rotation
          const efc = this.selectedEffect.content;
          this.resizing = {
            dir,
            clientX: e.clientX,
            clientY: e.clientY,
            x: efc.left,
            y: efc.top,
            w: efc.width,
            r: efc.rotate
          };
        } else {
          let afterCurrent = false;

          this.activeFragment.effects.some(eid => {
            const ef = this.allEffects[eid];
            const efr = ef.content;

            // TODO: rotation-aware hit test
            const center = {
              x: efr.left + efr.width / 2 + bcr.left,
              y: efr.top + efr.height / 2 + bcr.top
            };
            const unrotatedMouse = rotateBy({
              x: e.clientX,
              y: e.clientY
            }, center, -efr.rotate || 0);

            if (afterCurrent
              && betweenDelta(this.current, ef.start + this.activeFragment.start, ef.duration)
              && betweenDelta(unrotatedMouse.x, efr.left + bcr.left, efr.width)
              && betweenDelta(unrotatedMouse.y, efr.top + bcr.top, efr.height)
            ) {
              if (ef.locked || ef.hidden) {
                return false;
              }
              const { timelineFilter, shapeNames, videoSeriesTagMode } = this.$store.state;
              if (!matchFilter(ef, timelineFilter, shapeNames, videoSeriesTagMode)) {
                return false;
              }
              nextEffectId = ef.id;
              return true;
            }
            if (this.selectedEffect === ef) {
              afterCurrent = true;
            }
            return false;
          });
          const obj = {
            clientX: e.clientX,
            clientY: e.clientY,
            effectId: this.selectedEffect.id,
            ctrlKey,
            next: nextEffectId
          };
          this.dragging = obj;
        }
      }
    },
    handleContextMenu(e) {
      this.$store.dispatch('openEffectContextMenu', {
        x: e.clientX,
        y: e.clientY,
        effectId: this.$store.getters.selectedEffect ? this.selectedEffect.id : null,
        cover: true
      });
    },
    handleMouseMove(e) {
      // TODO: center is rotated, and so are origin and destination
      if (this.resizing) {
        const efc = this.selectedEffect.content;
        const usedRotation = this.resizing.r * Math.PI / 180;
        const deltaX = (e.clientX - this.resizing.clientX) / this.scale;
        const deltaY = (e.clientY - this.resizing.clientY) / this.scale;

        const rotatedOrig = rotateBy(
          { x: this.resizing.x, y: this.resizing.y },
          { x: this.resizing.x + this.resizing.w / 2, y: this.resizing.y },
          this.resizing.r
        );
        const rotatedDest = rotateBy(
          { x: this.resizing.x + this.resizing.w, y: this.resizing.y },
          { x: this.resizing.x + this.resizing.w / 2, y: this.resizing.y },
          this.resizing.r
        );

        if (e.shiftKey) {
          // TODO: along its projection
          let nextWidth, nextRotate = this.resizing.r;
          const usedDelta = Math.cos(usedRotation) * deltaX + Math.sin(usedRotation) * deltaY;
          if (this.resizing.dir === 'l') {
            nextWidth = this.resizing.w - usedDelta;
          } else {
            nextWidth = usedDelta + this.resizing.w;
          }
          if (nextWidth < 0) {
            nextWidth = -nextWidth;
            nextRotate = (nextRotate + 180) % 360;
          }
          nextWidth = Math.max(nextWidth, 1);
          efc.width = Math.round(nextWidth);
          efc.rotate = Math.round(nextRotate);
        } else {
          let total;
          if (this.resizing.dir === 'l') {
            // drag origin around dest
            total = {
              x: this.resizing.w * Math.cos(usedRotation) - deltaX,
              y: this.resizing.w * Math.sin(usedRotation) - deltaY
            };
          } else {
            // drag dest around origin
            total = {
              x: deltaX + this.resizing.w * Math.cos(usedRotation),
              y: deltaY + this.resizing.w * Math.sin(usedRotation)
            };
          }
          const w = Math.max(Math.sqrt(Math.pow(total.x, 2) + Math.pow(total.y, 2)), 1);
          efc.width = Math.round(w) || 0;
          efc.rotate = Math.round(Math.acos(total.x / w) * (total.y > 0 ? 1 : -1) * 180 / Math.PI);
        }

        let center;
        if (this.resizing.dir === 'l') {
          center = rotateBy(
            { x: rotatedDest.x - efc.width / 2, y: rotatedDest.y },
            rotatedDest,
            efc.rotate
          );
        } else {
          center = rotateBy(
            { x: rotatedOrig.x + efc.width / 2, y: rotatedOrig.y },
            rotatedOrig,
            efc.rotate
          );
        }

        efc.left = Math.round(center.x - efc.width / 2);
        efc.top = Math.round(center.y);
      }
    },
    handleMouseUp() {
      if (this.resizing) {
        if (this.selectedEffect.container) {
          const parentEffect = this.allEffects[this.selectedEffect.container];

          if (parentEffect && parentEffect.type === 'group') {
            this.$store.dispatch('adjustGroupSize', [parentEffect]);
          }
        }
        this.resizing = null;
        setTimeout(() => {
          document.body.classList.remove('unselectable');
        }, 0);
      }
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }
}
</script>
<style>
.line-selection {
  position: absolute;
  border: 0;
  pointer-events: auto;
  z-index: 0;
  cursor: move;
}

.line-selection:before {
  position: absolute;
  top: -6px;
  left: -6px;
  bottom: -6px;
  right: -6px;
  content: "";
}

.line-selection-handle--l,
.line-selection-handle--r {
  top: 50%;
}

.line-selection-handle--l {
  left: 0;
}

.line-selection-handle--r {
  right: 0;
}
</style>